import { default as getConfiguration } from './get';

export const configurations = [
  getConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/areas-of-advice/configurations/index.js